import React from 'react';
import NotfoundError from "../../images/error.svg";

export default function Notfound() {
  return (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "76vh", padding: "0" }}>
      <img src={NotfoundError} alt="Not Found" className="img-fluid"/>
    </div>
  );
}
